"use strict";

/**
 * Cross-asset constants and types pertaining to implementation details and configuration.
 * standardised headers, cookies etc.
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CampaignPreviewCookieValueHeader = exports.CampaignPreviewCookieName = void 0;
exports.CampaignPreviewCookieName = 'campaign_test';
exports.CampaignPreviewCookieValueHeader = 'x-campaign-preview-parameters';